import _ from 'lodash'

export const TAB = {
    PROBLEM: 'problem',
    INSOLVENCY: 'insolvency',
    LIQUIDATION: 'liquidation',
    UNRELIABLE_PAYER: 'unreliablePayer',
    DISTRAINT: 'distraint',
    DEBT: 'debt',
}

export const TABS = [TAB.PROBLEM, TAB.INSOLVENCY, TAB.LIQUIDATION, TAB.UNRELIABLE_PAYER, TAB.DISTRAINT, TAB.DEBT]
export const DEFAULT_TAB = _.first(TABS)

export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Portfolio.components.Workspace.components.Blocks.DetrimentalEvents'
